<template lang="html">
  <div class="validate-permit-widget">
    <h1 class="validate-header">{{ $t('car_validate.validate_permit') }}</h1>
    <hr />
    <div class="validate-container">
      <form class="form">
       
        <div class="validate-control" >
            <button type="submit" @click.prevent="validateCar()" class="validate-control__button"></button>

            <input type="text" class="validate-control__input"
              ref="carValidate"
              :placeholder="$t('car_validate.enter_car_placeholder')"
              v-model.trim="validateCarInput"
              @keydown.enter.prevent="validateCar()"
              name="validateCarInput"
              @keydown="stopInputAtDashAndSpace"
              @keyup="trimVehicleReg()"
            >

            <div class="validate-control__indicator validate-control__indicator-valid" 
                  v-if="isValid">
              <i class="fa fa-check"></i>
            </div>

            <div class="link link--orange validate-control__indicator validate-control__indicator-invalid" 
                  v-else-if="isInvalid" 
                  @click="clearCarValidation()">
              <i class="icon icon--cross"></i>
            </div>
        </div>

        <button type="submit" @click.prevent="validateCar()" class="btn btn--main validate-container__button">{{ $t('common.validate') }}</button>

        <div v-show="isLoading" class="loader"></div>

        <p class="validate-container__validation-message" v-if="isInvalid && !isLoading">
          {{ $t('car_validate.no_permit') }}
        </p>
      </form>

      <div class="validate-container__permit-container" v-if="validPermits.length > 0 && !isLoading">
        <template v-for="permit in validPermits">
          <router-link :to="{name: 'permit', params: {id: permit.id} }" class="permit-wrapper">
          
            <div class="validate-container__permit-authority" v-if="permit.partner">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--contact-icon"></i>
              </div>
              <span class="">{{ permit.partner.name }}</span>
              <h4 class="validate-container__contact-person-name" v-if="permit.partner.name">{{ $t('common.tenant') }}</h4>
            </div>

            <div class="validate-container__permit-authority" v-if="permit.vehicleOwnerName">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--contact-icon"></i>
              </div>
              <span class="">{{ permit.vehicleOwnerName }}</span>
              <h4 class="validate-container__contact-person-name">{{ $t('car_validate.permit_owner') }}</h4>
            </div>

            <div class="validate-container__permit-authority" v-if="permit.product && permit.product.zones.length > 0">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--location-icon"></i>
              </div>
              <span class="" v-for="zone in permit.product.zones">
                {{ zone.address }}
                <span class="address-seperator"></span>
                </span>
              <h4 class="validate-container__contact-person-name">{{ $tc('common.zones', permit.product.zones) }}</h4>
            </div>

            <div class="icon icon--arrow"></div>
          </router-link>
        </template>
      </div>
      <div class="validate-container__permit-container" v-if="validParkings.length > 0 && !isLoading">
        <template v-for="parking in validParkings">
          <router-link :to="{name: 'parking', params: {id: parking.id} }" class="permit-wrapper">
          
            <div class="validate-container__permit-authority" v-if="parking.partner">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--contact-icon"></i>
              </div>
              <span class="">{{ parking.partner.name }}</span>
              <h4 class="validate-container__contact-person-name" v-if="parking.partner.name">{{ $t('common.tenant') }}</h4>
            </div>

            <div class="validate-container__permit-authority" v-if="parking.zones">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--location-icon"></i>
              </div>
              <span class="" v-for="zone in parking.zones">
                {{ zone.address }}
                <span class="address-seperator"></span>
                </span>
              <h4 class="validate-container__contact-person-name">{{ $tc('common.zones', parking.zones) }}</h4>
            </div>

            <div class="icon icon--arrow"></div>
          </router-link>
        </template>
      </div>
      <div class="validate-container__permit-container" v-if="validResidents.length > 0 && !isLoading">
        <template v-for="resident in validResidents">
          <router-link :to="{name: 'user', params: {id: resident.id} }" class="permit-wrapper">
            <div class="validate-container__permit-authority">
              <div class="icon-wrapper">
                <i class="validate-container__permit-owner--contact-icon"></i>
              </div>
              <span>{{ resident.name }}</span>
              <h4 class="validate-container__contact-person-name" v-if="resident.name">{{ $t('common.user') }}</h4>
            </div>

            <div class="icon icon--arrow"></div>
          </router-link>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  computed: {
    isValid() {
      return this.validPermits.length > 0 ||
      this.validParkings.length > 0 ||
      this.validResidents.length > 0;
    },
    isInvalid() {
      return this.isInvalidPermit === true &&
      this.isInvalidParking === true &&
      this.isInvalidResident === true;
    },
    ...mapGetters({
      validPermits: 'landlord/validatePermit/validPermits',
      validParkings: 'landlord/validatePermit/validParkings',
      validResidents: 'landlord/validatePermit/validResidents',
      user: 'user/user/user',
    }),
  },
  data() {
    return {
      validateCarInput: '',
      isInvalidPermit: false,
      isInvalidParking: false,
      isInvalidResident: false,
      // isInvalid: false,
      isLoading: false,
      type: '',
    };
  },
  created() {
    this.$store.commit(`landlord/validatePermit/${mTypes.CLEAR_STATE}`);
  },
  methods: {
    trimVehicleReg() {
      if (this.validateCarInput) {
        this.validateCarInput = this.validateCarInput.replace('-', '').replace(' ', '');
      }
    },
    stopInputAtDashAndSpace(event) {
      if (event.key === '-' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    validateCar() {
      this.isLoading = false;
      // this.isInvalid = false;
      this.isInvalidPermit = false;
      this.isInvalidParking = false;
      this.isInvalidResident = false;
      this.$store.commit(`landlord/validatePermit/${mTypes.CLEAR_STATE}`);
      const currentValue = this.validateCarInput.length; /* user input value */
      if (currentValue > 0) {
        this.type = currentValue === 9 ? 'cardNumber' : 'carNumber';
        this.isLoading = true;
        this.makeRequest();
      } else {
        this.$refs.carValidate.click();
        this.validateCarInput = '';
        this.isLoading = false;
      }
      return currentValue;
    },
    makeRequest() {
      this.$store.dispatch('landlord/validatePermit/validatePermit', { type: this.type, input: this.validateCarInput, user: this.user })
        .then(() => {
          if (this.validPermits.length === 0) {
            this.isInvalidPermit = true;
          }
          if (this.type === 'carNumber') {
            this.$store.dispatch('landlord/validatePermit/validateParkings', { type: this.type, input: this.validateCarInput, user: this.user })
              .then(() => {
                if (this.validParkings.length === 0) {
                  this.isInvalidParking = true;
                }
                this.isLoading = false;
              })
              .catch((error) => {
                console.log('failed to validate parking', error);
              });

            this.$store.dispatch('landlord/validatePermit/validateResidents', { type: this.type, input: this.validateCarInput, user: this.user })
              .then(() => {
                if (this.validResidents.length === 0) {
                  this.isInvalidResident = true;
                }
                this.isLoading = false;
              })
              .catch((error) => {
                console.log('failed to validate resident', error);
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log('failed to validate parking', error);
        });
    },
    clearCarValidation() {
      this.validateCarInput = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';
@import '~styles/icons.scss';
@import '~styles/_animations.scss';

.validate-permit-widget {
  padding: 15px 30px 25px;
  margin: 0 10px 10px 0;
  background-color: lighten(#F2F3F3, 1.5%);
  border: solid 1px darken(#F2F3F3, 3%);

  @media screen and (max-width: 1115px) {
    margin: 0 0 10px 0;
  }

  .validate-header {
    color: var(--grey-one);
    font-weight: 900;
    text-align: center;
  }

  .validate-container {
    margin: 50px 0 50px 0;

    .permit-wrapper {
      @include shadow(1);
      padding: 30px 30px 50px 30px;
      background-color: darken(#fff, 2.5%);
      border: solid 1px var(--grey-five);
      border-radius: 5px;
      transition: all 300ms ease-in-out;
      margin: 15px 0 0 5px;
      position: relative;
      cursor: pointer;
      display: block;

      &:hover {
        background-color: var(--white);
        border: solid 1px var(--white);
        @include shadow(2);
        transform: scale(1.045);
      }

      &:hover,
      &:visited {
        color: #000;
      }
    }

    &__button {
      margin-top: 20px;
    }

    &__validation-message {
      text-align: center;
      animation: errorFadeOut 7500ms ease-in-out;
      color: var(--brand-red);
    }

    .validate-control {
      display: flex;
      align-items: center;
      background-color: var(--white);
      position: relative;

      &__button {
        display: inline-block;
        width: 80px;
        height: 60px;
        background: url('~assets/icons/search.svg') 50% 50% no-repeat;
        cursor: pointer;
        background-color: var(--white);
        border-right: 1px solid var(--grey-five);
        border-left: transparent;
        border-top: transparent;
        border-bottom: transparent;
      }

      &__input {
        width: 100%;
        height: 60px;
        color: var(--black);
        font-weight: 900;
        font-size: 18px;
        text-transform: uppercase;
        border: none;
        padding-left: 5px;
      }

      input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px var(--white) inset;
      }

      &__input::placeholder {
        font-size: 11px;
      }

      &__indicator {
        font-weight: 900;
        position: absolute;
        right: 5px;

        &-valid {
          color: var(--brand-green);
        }

        &-invalid {
          color: var(--brand-red);
        }
      }

      &__input::placeholder {
        text-transform: lowercase;
      }
    }

    &__permit-container {
      margin: 15px 0 15px 0;
    }

    &__parking-permit {
      color: var(--grey-one);
      font-weight: 900;
    }

    &__permit-owner {
      color: var(--grey-one);
      font-weight: 900;
      animation: subtleJumpInOut 150ms ease-in-out;

      &--text-orange {
        color: var(--brand-orange);
        position: relative;
      }

      &--contact-icon {
        position: absolute;
        background: url('~assets/icons/contact.svg') 50% 50% no-repeat;
        width: 26px;
        height: 34px;
        top: -10.5px;
        left: -5px;
        background-size: contain;
        &:after {
          content: '';
          position: absolute;
          height: 50px;
          width: 1px;
          right: -18px;
          top: 0;
          background-color: var(--gray-three);
        }
        &:before {
          content: '';
          position: absolute;
          height: 30px;
          width: 1px;
          right: 16px;
          top: 33.5px;
          background-color: var(--gray-three);
          transform: rotate(90deg);
        }
      }

      &--location-icon {
        position: absolute;
        background: url('~assets/icons/location.svg') 50% 50% no-repeat;
        width: 26px;
        height: 34px;
        top: -10.5px;
        left: -5px;
        background-size: contain;

        &:after {
          content: '';
          position: absolute;
          height: 100px;
          width: 1px;
          right: -18px;
          top: -10px;
          background-color: var(--gray-three);
        }

        &:before {
          content: '';
          position: absolute;
          height: 30px;
          width: 1px;
          right: 16px;
          top: 33.5px;
          background-color: var(--gray-three);
          transform: rotate(90deg);
        }
      }

    }

    &__permit-authority {
      margin: 0px 0 35px 0;
      text-align: center;
      text-transform: capitalize;
      position: relative;

      &:after {
        content: '';
        width: 100%;
        height: 1px;
        background-color: var(--gray-three);
        position: absolute;
        left: 0;
        bottom: -20px;
      }

      .icon-wrapper {
        width: 30%;
      }

      h4 {
        display: inline-block;
        margin: 0;
        text-align: right;
        float: right;
        position: relative;
      }

      span {
        font-weight: 900;
        font-size: 16px;
      }
    }

    .icon {
      &.icon--arrow {
        color: var(--brand-blue);
        float: right;
        transition: all 275ms ease-in-out;
        &:hover {
          color: var(--brand-orange);
        }
      }
    }

    &__check-permits {
      float: right;
      margin: -6.5px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ValidatePermit.vue